import Vue from "vue"
import Vuex from "vuex"
import pathify from "vuex-pathify"

import auth from "./auth"
import customers from "./customers"
import contacts from "./contacts"
import supportContracts from "./supportContracts"
import productContracts from "./productContracts"
import courseContracts from "./courseContracts"
import contractTypes from "./contractTypes"
import courseTypes from "./courseTypes"
import estimates from "./estimates"
import estimateLines from "./estimateLines"
import marketingActions from "./marketingActions"
import products from "./products"
import productTypes from "./productTypes"
// import estimates from "./estimates"
// import works from "./works"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    customers,
    contacts,
    supportContracts,
    productContracts,
    courseContracts,
    contractTypes,
    estimates,
    estimateLines,
    marketingActions,
    products,
    productTypes,
    courseTypes
    // estimates,
    // works
  },
  plugins: [pathify.plugin]
})
